<template>
	<divBox class="realTimeBox" :title="'最新告警列表信息'">
		<dv-scroll-board :config="config" class="margin-top-sm realTimeList">
		</dv-scroll-board>
	</divBox>
</template>

<script>
import divBox from '../../components/divBox.vue'
import { formatTime } from '@/utils/index'
import { dataInterface } from '@/api/dataInterfaceApi';

export default {
	data() {
		return {
			config: {
				headerBGC: "rgba(53, 149, 147, 0.2)",
				headerHeight: 42,
				carousel: "single",
				hoverPause: true,
				oddRowBGC: "rgba(53, 149, 147, 0)",
				evenRowBGC: "rgba(53, 149, 147, 0)",
				rowNum: 3, //表格行数
				header: ["告警时间", "城市", "站点", "设备编码", "告警类别", "告警内容"],
				data: [],
			},
			config1: {
				headerBGC: "rgba(53, 149, 147, 0.2)",
				headerHeight: 42,
				carousel: "single",
				hoverPause: true,
				oddRowBGC: "rgba(53, 149, 147, 0)",
				evenRowBGC: "rgba(53, 149, 147, 0)",
				rowNum: 2, //表格行数
				header: ["告警时间", "设备编码", "告警类别", "告警内容"],
				data: [],
			},
			secTitle: {
				title: "最新告警列表信息",
			},
		};
	},
	components: {
		divBox
	},
	props: {},
    inject: ['cityUpdate'],
    computed: {
        computedProperty() {
        	return this.cityUpdate()
        }
    },
    watch: {
        computedProperty(val) {
			this.getData(val)
        },
    },
	mounted() {},
	methods: {
		getData(data) {
			// if (this.type == "singleSite") {
			// 	this.selectStationAlarm(data);
			// } else {
				this.selectStationAlarmList(data);
			// }
		},
		// //站点--告警列表
		// selectStationAlarm(data = {}) {
		// 	let _this = this;
		// 	let params = {
		// 		"enCode": "gaojingliebiao-TiDB",
		// 		"@station_id": data.stationId
		// 	}
		// 	dataInterface
		// 		.dataFaceApi(params)
		// 		.then((res) => {
		// 			if (!res) return;
		// 			console.log("最新告警列表", res)
		// 			let newList = [];
		// 			[...res].map(item => {
		// 				let arrlist = [
		// 					formatTime(item.timeOccurrence, 'yyyy-MM-dd'),
		// 					item.alarmEquipmentCode,
		// 					item.alarmClassification,
		// 					item.alarm_coent,
		// 				];
		// 				newList.push(arrlist)
		// 			});
		// 			_this.config1 = {
		// 				headerBGC: "rgba(53, 149, 147, 0.2)",
		// 				headerHeight: 42,
		// 				carousel: "single",
		// 				hoverPause: true,
		// 				oddRowBGC: "rgba(53, 149, 147, 0)",
		// 				evenRowBGC: "rgba(53, 149, 147, 0)",
		// 				rowNum: 3, //表格行数
		// 				header: ["告警时间", "设备编码", "告警类别", "告警内容"],
		// 				data: newList,
		// 			};
		// 		})
		// 		.catch((err) => {
		// 			console.log(err);
		// 		});
		// },
		selectStationAlarmList(data = {}) {
			let _this = this;
			let params = {};
			if (data) {
				params = {
					"enCode": "TiDB-shengshiqu-zuixingaojingliebiaoxinxi",
					"@province": data.province || data.city || data.district
				}
			} else {
				params = {
					"enCode": "TiDB-quanguo-zuixingaojingliebiaoxinxi" //TiDB-全国-最新告警列表信息
				}
			}
			dataInterface
				.dataFaceApi(params)
				.then((res) => {
					if (!res) return;
					console.log("最新告警列表", res)
					let newList = [];
					[...res].map(item => {
						let arrlist = [
							formatTime(item.time_occurrence, 'yyyy-MM-dd'),
							item.cityName,
							item.stationName,
							item.alarmEquipmentCode,
							item.alarm_classification,
							item.alarm_name
						];
						newList.push(arrlist)
					});
					_this.config = {
						headerBGC: "rgba(53, 149, 147, 0.2)",
						headerHeight: 42,
						carousel: "single",
						hoverPause: true,
						oddRowBGC: "rgba(53, 149, 147, 0)",
						evenRowBGC: "rgba(53, 149, 147, 0)",
						rowNum: 5, //表格行数
						header: ["告警时间", "城市", "站点", "设备编码", "告警类别", "告警内容"],
						data: newList,
					};
				})
				.catch((err) => {
					console.log(err);
				});
		},
	},
}
</script>
<style lang="scss" scoped>
	.realTimeBox {
		width: 100%;
		height: 515px;
		// margin-top: 15px;
		background: linear-gradient(to bottom, #0B1114, #131D23);
		position: relative;
		padding: 10px 20px 40px 20px;
		.realTimeList {
			width: 100%;
			height: 380px;
			font-size: 8px;
		}
	}
</style>
